/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationProgram } from '../../models/education-program';

export interface GetEducationProgram$Params {
  id: string;
}

export function getEducationProgram(http: HttpClient, rootUrl: string, params: GetEducationProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationProgram>> {
  const rb = new RequestBuilder(rootUrl, getEducationProgram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationProgram>;
    })
  );
}

getEducationProgram.PATH = '/educationprogram/{id}';
